import {
  Building2,
  HouseWifi,
  LayoutDashboard,
  LucideIcon,
  MonitorIcon,
  TvMinimalPlay,
  Users
} from "lucide-react";
import { ComponentType, lazy } from "react";

// Lazy load components for better performance
const DashboardView = lazy(() => import("@/modules/dashboard/view"));
const AccountView = lazy(() => import("@/modules/user/view/account"));
 const RoomsView = lazy(() => import("@/modules/rooms/view"));
 const MeetingsView = lazy(() => import("@/modules/meetings/view"));
const LoginPage = lazy(
  () => import("@/modules/authentication/view/login-page")
);
const DeviceView = lazy(() => import("@/modules/device/view"));
const UserList = lazy(() => import("@/modules/user/view/user-list"));
const OrganizationsView = lazy(() => import("@/modules/organizations/view"));
export type MenuItemType = {
  title: string;
  url: string;
  external?: string;
  icon?: LucideIcon;
  isActive?: boolean;
  items?: MenuItemType[];
  role?: string[];
  permissionCode?: string; // Permission code để check quyền truy cập
};

export type MenuType = MenuItemType[];

// Route configuration for router
export type RouteConfigType = {
  path: string;
  component: ComponentType<Record<string, unknown>>;
  title: string;
  requiresAuth?: boolean;
};

export const routeConfig: RouteConfigType[] = [
  {
    path: "/dashboard",
    component: DashboardView,
    title: "Dashboard",
    requiresAuth: true,
  },
  {
    path: "/account",
    component: AccountView,
    title: "Tài khoản",
    requiresAuth: true,
  },
  {
    path: "/meetings",
    component: MeetingsView,
    title: "Cuộc họp",
    requiresAuth: true,
  },
  {
    path: "/rooms",
    component: RoomsView,
    title: "Phòng họp",
    requiresAuth: true,
  },
  {
    path: "/devices",
    component: DeviceView,
    title: "Thiết bị",
    requiresAuth: true,
  },
  {
    path: "/users",
    component: UserList,
    title: "Người dùng",
    requiresAuth: true,
  },
  {
    path: "/organizations",
    component: OrganizationsView,
    title: "Tổ chức",
    requiresAuth: true,
  },

];

export const navMain: MenuType = [
  {
    title: "Trang chủ",
    url: "/dashboard",
    icon: LayoutDashboard,
    role: ["ADMIN", "USER"],
    permissionCode: "", // Permission code để check quyền
  },
  {
    title: "Cuộc họp",
    url: "/meetings",
    icon: TvMinimalPlay,
    role: ["ADMIN", "USER"],
    permissionCode: "view_meeting",
  },
  {
    title: "Phòng họp",
    url: "/rooms",
    icon: HouseWifi,
    role: ["ADMIN", "USER"],
    permissionCode: "view_room",
  },
  {
    title: "Thiết bị",
    url: "/devices",
    icon: MonitorIcon,
    role: ["ADMIN", "USER"],
    permissionCode: "view_device",
  },
  {
    title: "Người dùng",
    url: "/users",
    icon: Users,
    role: ["ADMIN"],
    permissionCode: "view_user",
  },
  {
    title: "Tổ chức",
    url: "/organizations",
    icon: Building2,
    role: ["ADMIN"],
    permissionCode: "",
  },
];

// Generate route titles from route config
export const routeTitles: Record<string, string> = routeConfig.reduce(
  (acc, route) => {
    acc[route.path] = route.title;
    return acc;
  },
  {} as Record<string, string>
);
